export enum TaxiCorporationUnbilledOrdersListRequestOrder {
  START_TIME_ASC = "START_TIME_ASC",
  START_TIME_DESC = "START_TIME_DESC",
  HUMAN_ID_ASC = "HUMAN_ID_ASC",
  HUMAN_ID_DESC = "HUMAN_ID_DESC",
}

export type TaxiCorporationUnbilledOrdersListQueryParams = {
  order?: TaxiCorporationUnbilledOrdersListRequestOrder;
  limit: number;
  offset?: number;
  excludeCargoCompany?: string;
  startTimeSince?: string;
  startTimeTo?: string;
  humanId?: number;
  address?: string;
  startAddress?: string;
  midAddress?: string;
  endAddress?: string;
  passenger?: string;
  dispatch?: string;
  client?: string;
  externalId?: string;
  taxi?: string;
  driver?: string;
  isCancelled?: boolean;
};

type TaxiCorporationUnbilledOrdersListRequest = {
  taxiCorporationUuid: string;
  order?: TaxiCorporationUnbilledOrdersListRequestOrder;
  limit: number;
  offset?: number;
  excludeCargoCompany?: string;
  startTimeSince?: string;
  startTimeTo?: string;
  humanId?: number;
  address?: string;
  startAddress?: string;
  midAddress?: string;
  endAddress?: string;
  passenger?: string;
  dispatch?: string;
  client?: string;
  externalId?: string;
  taxi?: string;
  driver?: string;
  isCancelled?: boolean;
};

export default TaxiCorporationUnbilledOrdersListRequest;
